import { useState } from 'react';
import Asistente from './Asistente';
import Login from './Login';
import { sesionActiva, cerrarSesion } from './apidoo';

function App() {
  const [autenticado, setAutenticado] = useState(sesionActiva);

  if (!autenticado) {
    return <Login onLogin={() => setAutenticado(true)} />;
  }

  return (
    <Asistente
      onCerrarSesion={() => { cerrarSesion(); setAutenticado(false); }}
    />
  );
}

export default App;
